import { required, numeric, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

// บังคับนับแค่เงินสด — ช่องทางอื่นไม่มีลิ้นชักให้นับ (ยอดจริงมาจาก statement/slip ทีหลัง)
// จึงเป็นการ "ยืนยันยอด" แบบไม่บังคับ ปล่อยว่างได้
export default function (formState) {
  return {
    form: {
      actual_cash: {
        required: helpers.withMessage(i18n.global.t('Please enter a cash.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cash.'), numeric)
      },
      note: {
      }
    }
  }
};
